import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
  defaultReviewQuestionnaireState,
  defaultReviewsQuestionnaire,
} from "./deafaultState";
import {
  CLEAR_REVIEWS_QUESTIONNAIRE,
  CLEAR_REVIEWS_QUESTIONNAIRE_STATE,
  FETCH_REVIEWS_QUESTIONNAIRE_FAILED,
  FETCH_REVIEWS_QUESTIONNAIRE_LIST_FAILED,
  FETCH_REVIEWS_QUESTIONNAIRE_LIST_PROGRESS,
  FETCH_REVIEWS_QUESTIONNAIRE_LIST_SUCCESS,
  FETCH_REVIEWS_QUESTIONNAIRE_PROGRESS,
  FETCH_REVIEWS_QUESTIONNAIRE_SUCCESS,
  GENERATE_REVIEW_QR_FAILED,
  GENERATE_REVIEW_QR_PROGRESS,
  GENERATE_REVIEW_QR_SUCCESS,
} from "./ReviewQuestionnaireActions";
import { ReviewQuestionnaireActions } from "./index";

export const reviewQuestionnaireReducer = (
  state: IStoreState["reviewQuestionnaire"] = defaultReviewQuestionnaireState,
  action: ReviewQuestionnaireActions,
) => {
  switch (action.type) {
    case FETCH_REVIEWS_QUESTIONNAIRE_LIST_PROGRESS: {
      return produce(state, (draft) => {
        draft.list.loading = LoadState.InProgress;
        draft.list.data = [];
        draft.list.error = null;
      });
    }
    case FETCH_REVIEWS_QUESTIONNAIRE_LIST_SUCCESS: {
      const { data, totalRecords, currentRecords } = action.payload;
      return produce(state, (draft) => {
        draft.list.loading = LoadState.Loaded;
        draft.list.data = data;
        draft.list.currentRecords = currentRecords;
        draft.list.totalRecords = totalRecords;
      });
    }
    case FETCH_REVIEWS_QUESTIONNAIRE_LIST_FAILED: {
      return produce(state, (draft) => {
        draft.list.loading = LoadState.Failed;
      });
    }

    case FETCH_REVIEWS_QUESTIONNAIRE_PROGRESS: {
      return produce(state, (draft) => {
        draft.questionnaire.loading = LoadState.InProgress;
        draft.questionnaire.data = defaultReviewsQuestionnaire;
        draft.questionnaire.error = null;
      });
    }
    case FETCH_REVIEWS_QUESTIONNAIRE_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draft) => {
        draft.questionnaire.loading = LoadState.Loaded;
        draft.questionnaire.data = data;
      });
    }
    case FETCH_REVIEWS_QUESTIONNAIRE_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draft) => {
        draft.questionnaire.loading = LoadState.Failed;
        draft.questionnaire.error = errorMessage;
      });
    }
    case CLEAR_REVIEWS_QUESTIONNAIRE: {
      return produce(state, (draft) => {
        draft.questionnaire.loading = LoadState.NotLoaded;
        draft.questionnaire.data = defaultReviewsQuestionnaire;
        draft.questionnaire.error = null;
      });
    }
    case CLEAR_REVIEWS_QUESTIONNAIRE_STATE: {
      return defaultReviewQuestionnaireState;
    }

    case GENERATE_REVIEW_QR_PROGRESS: {
      return produce(state, (draft) => {
        draft.qrCode.loading = LoadState.InProgress;
        draft.qrCode.base64 = null;
        draft.qrCode.error = null;
      });
    }
    case GENERATE_REVIEW_QR_SUCCESS: {
      const { base64 } = action.payload;
      return produce(state, (draft) => {
        draft.qrCode.loading = LoadState.Loaded;
        draft.qrCode.base64 = base64;
        draft.qrCode.error = null;
      });
    }
    case GENERATE_REVIEW_QR_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draft) => {
        draft.qrCode.loading = LoadState.Failed;
        draft.qrCode.base64 = null;
        draft.qrCode.error = errorMessage;
      });
    }

    default:
      return state;
  }
};
